import { render, staticRenderFns } from "./Progress.vue?vue&type=template&id=4b2c4c68&scoped=true&lang=pug"
import script from "./Progress.vue?vue&type=script&lang=js"
export * from "./Progress.vue?vue&type=script&lang=js"
import style0 from "./Progress.vue?vue&type=style&index=0&id=4b2c4c68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2c4c68",
  null
  
)

export default component.exports